function checkCustomMeasurementInputs() {
  var allInputsFilled = true;

  $('.single_custom-size .required-measurement').each(function() {
    if ($.trim($(this).val()) === '') {
      allInputsFilled = false;
      $(this).css('border', '1px solid #ff1a1a');
    } else {
      $(this).css('border', '1px solid #1a1a1a');
    }
  });

  $('.single_custom-size .optional-measurement').css('border', '1px solid #d9d9d9');

  $('.product-form__buttons button').prop('disabled', !allInputsFilled);
}


$('.single_item').click(function() {
  var index = $(this).index() - 1;

  $('.row-scroll-content').removeClass('active');
  $('.row-scroll-content:eq(' + index + ')').addClass('active');

  var size = $(this).find('div').first().text().trim();
  $('.data-size-value').empty().text(size);

  if ($(this).hasClass('single_item-custom')) {
    $('.row-scroll').hide();
    $('.shopify-payment-button').hide();
    $('.single_custom-size').show();

    $('.product-form__buttons button').prop('disabled', true);
    checkCustomMeasurementInputs();
  } else {
    $('.product-form__buttons button').prop('disabled', false);
    $('.row-scroll').show();
    $('.shopify-payment-button').show();
    $('.single_custom-size').hide();

    $('.single_custom-size .required-measurement').val('');
    $('.single_custom-size .optional-measurement').val('');

    $('.single_custom-size .required-measurement').css('border', '1px solid #ff1a1a');
    $('.single_custom-size .optional-measurement').css('border', '1px solid #d9d9d9');
  }
});


$(document).on('input', '.single_custom-size .required-measurement', function() {
  checkCustomMeasurementInputs();
});


$(document).on('input', '.single_custom-size .optional-measurement', function() {
  $(this).css('border', '1px solid #d9d9d9');
});


document.addEventListener('click', function(e) {
  const target = e.target.closest('.man-color-value');
  if (!target) return;

  setTimeout(() => {
    const value = target.getAttribute('value') || target.dataset.value || target.innerText.trim();

    const colorValueDisplay = document.getElementById('color-values');
    if (colorValueDisplay) {
      colorValueDisplay.textContent = value;
    }

    document.querySelectorAll('.man-color-value').forEach(el => {
      el.classList.remove('active');
    });

    target.classList.add('active');
  }, 1000);
});



  // function filterImagesByColor(selectedColor) {
  //   let imageSelector;
  //   if ($(window).width() >= 750) {
  //     imageSelector = '.thumbnail-slider img';
  //   } else {
  //     imageSelector = 'slider-component img';  
  //   }

  //   $(imageSelector).each(function () {
  //     const altText = $(this).attr('alt')?.toLowerCase() || '';
  //     const $li = $(this).closest('li');

  //     if (altText.includes(selectedColor.toLowerCase())) {
  //       $li.removeClass('hidden');
  //     } else {
  //       $li.addClass('hidden');
  //     }
  //   });
  // }

  // function getSelectedColor() {
  //   return $('.swatch-input__input:checked').val();
  // }

  // const initialCheckedValue = getSelectedColor();
  // filterImagesByColor(initialCheckedValue);

  // $(document).on('change', '.swatch-input__input', function () {
  //   const selectedColor = getSelectedColor();
  //   filterImagesByColor(selectedColor);
  // });

  // $(window).resize(function() {
  //   const selectedColor = getSelectedColor();
  //   filterImagesByColor(selectedColor);
  // });
